enum UnprocessedExcludedProviders {
  All = "---",
  Yes = "Yes",
  No = "No"
}

export default UnprocessedExcludedProviders;